module.exports = "<p style=\"text-align: center;\nfont-size: smaller;\nfont-weight: 700;\nbackground: border-box;\">\n $ {{totalcobro}}\n</p>\n"